export const STAKING_TYPE = {
  NORMAL: "normal",
  PERCENT: "percent",
};
